import { Link } from 'react-router-dom';

export function MarketingHome() {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="px-6 py-4 flex items-center justify-between">
        <Link to="/" className="font-display italic text-2xl">
          MahjongHub
        </Link>
        <Link to="/admin/login" className="text-sm underline">
          Sign in
        </Link>
      </header>
      <main className="flex-1 flex items-center justify-center px-6">
        <div className="max-w-xl text-center space-y-6">
          <h1 className="font-display text-5xl leading-tight">Run your mahjong club with grace.</h1>
          <p className="text-ink-muted">
            Member management, event sign-ups, table auto-assignment, dues payments, and SMS reminders — built for
            mahjong clubs.
          </p>
          <div className="flex items-center justify-center gap-3">
            <Link
              to="/admin/signup"
              className="inline-block bg-navy-900 text-cream-100 px-6 py-3 rounded-xl font-medium"
            >
              Start a club
            </Link>
            <Link to="/admin/login" className="inline-block px-6 py-3 rounded-xl border border-navy-900 text-navy-900">
              Sign in
            </Link>
          </div>
        </div>
      </main>
      {/* TODO(section-5/7): full marketing page, pricing, features, testimonials */}
    </div>
  );
}
